(() => {
  const buttons = [
    ...Array.from(document.querySelectorAll<HTMLElement>("[data-button]")),
  ];

  [...buttons].forEach((button) => {
    button.addEventListener("mousedown", (event: MouseEvent) => {
      const currentButton = event.currentTarget as HTMLElement;

      const x = event.clientX - currentButton.getBoundingClientRect().left;
      const y = event.clientY - currentButton.getBoundingClientRect().top;

      if (currentButton) {
        currentButton.style.setProperty("--x", `${x}px`);
        currentButton.style.setProperty("--y", `${y}px`);
        currentButton.style.setProperty("--size", "50px");
        currentButton.style.setProperty("--opacity", "1");

        setTimeout(() => {
          currentButton.style.setProperty("--size", "500px");
        }, 250);

        setTimeout(() => {
          currentButton.style.setProperty("--size", "0px");
          currentButton.style.setProperty("--opacity", "0");
        }, 500);
      }
    });
  });
})();

export {};
